import React, { Component } from 'react';
import { calculateBetReturn } from 'utils/calculations'
import { convertCurrency } from 'utils/converters'
import ReactHighcharts from 'react-highcharts'
import { allBookmakers as bookmakers } from 'config'

export default class ProfitGraph extends Component {
  constructor(props) {
    super(props)
    this.state = {
      excludeBookmakers: []
    }
  }

  get generateProfitEvChartOptions() {
    const betReturns = []
    const betEVs = []
    this.props.userbets
      .filter(b => this.state.excludeBookmakers.indexOf(b.bookmaker._id) === -1)
      .forEach(bet => {
        betReturns.push(convertCurrency(bet.currency,
                                        this.props.mainCurrency,
                                        calculateBetReturn(bet.wager, bet.odds, bet.status) - bet.wager,
                                        this.props.currencies))
        if (!bet.edge)
          betEVs.push(0)
        else {
          betEVs.push(convertCurrency(bet.currency, this.props.mainCurrency, bet.wager * bet.edge / 100, this.props.currencies))
        }
      })
    for (let i = 1; i < betReturns.length; i++) {
      betReturns[i] += betReturns[i-1]
      betReturns[i-1] = Math.round(betReturns[i-1] * 100) / 100
      betEVs[i] += betEVs[i-1]
      betEVs[i-1] = Math.round(betEVs[i-1] * 100) / 100
    }
    betEVs[betEVs.length - 1] = Math.round(betEVs[betEVs.length - 1] * 100) / 100
    betReturns[betReturns.length - 1] = Math.round(betReturns[betReturns.length - 1] * 100) / 100
    return {
      chart: {
        zoomType: 'x',
        type: 'line'
      },
      title: {
        text: ''
      },
      xAxis:{
        title: {
          text: 'Number of bets'
        }
      },
      yAxis: {
        title: {
          text: 'Amount in ' + this.props.mainCurrency
        }
      },
      series: [{
        data: betReturns,
        name: 'Profit'
      }, {
        data: betEVs,
        name: 'EV'
      }]
    }
  }

  getBookmakers(bets=this.props.userbets) {
    return bets.map(b => b.bookmaker._id).filter((v, index, self) => {
      return self.indexOf(v) === index
    })
  }

  onBookmakersChanged(bookmakers) {
    this.setState({
      excludeBookmakers: this.getBookmakers().filter(b => bookmakers.indexOf(b) === -1)
    })
  }

  render() {
    return (
      <div className='panel profit-graph-container'>
        <header className='panel-heading clearfix'>
          <span className='col-md-10'>
            Total profit vs EV
          </span>
          <span className='col-md-2'>
            Filter bookmakers
          </span>
        </header>
        <div className='panel-body'>
          <div className='col-md-10'>
            <ReactHighcharts config={this.generateProfitEvChartOptions} />
          </div>
          <div className='col-md-2'>
            <ProfitGraphForm bookmakers={this.getBookmakers()} onSubmit={this.onBookmakersChanged.bind(this)}/>
          </div>
        </div>
      </div>
    );
  }
}


class ProfitGraphForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bookmakers: this.props.bookmakers
    }
  }

  componentDidMount() {
    this.setState({
      bookmakers: this.props.bookmakers
    })
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.onSubmit(this.state.bookmakers)
  }

  onChange(b, checked) {
    if (checked) {
      this.setState({
        bookmakers: [...this.state.bookmakers, b]
      })
    } else {
      this.setState({
        bookmakers: this.state.bookmakers.filter(cur => cur !== b)
      })
    }
  }

  render() {
    return (
      <form className='form-horizontal' onSubmit={this.onSubmit.bind(this)} className='profit-graph-form'>
        <div className='form-group profit-graph-scroll'>
          {this.props.bookmakers.map(b => (
            <div className='checkbox' key={b}>
              <label>
                <input
                  type='checkbox'
                  checked={this.state.bookmakers.indexOf(b) !== -1}
                  onChange={(e) => this.onChange(b, e.target.checked)}
                /> { bookmakers[b] }
              </label>
            </div>
          ))}
        </div>
        <div className='btn-group col-xs-12'>
          <button className='btn btn-success' type='submit'>Update</button>
          { this.state.bookmakers.length === 0 ? (
              <button className='btn btn-default'
                type='button'
                onClick={() => this.setState({bookmakers: this.props.bookmakers })}>Select all
              </button>
              ) : (
              <button className='btn btn-warning'
                type='button'
                onClick={() => this.setState({bookmakers: [] })}>Deselect all
              </button>
            )
          }
        </div>
      </form>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/analytics/ProfitGraph.js
 **/